import { z } from 'zod'

const loginSchema = z.object({
  email: z.string().email({
    message: 'Only valid email is allowed'
  }),
  password: z.string().min(2, {
    message: 'This field is required'
  })
})

const forgotPasswordSchema = z.object({
  email: z.string().email({
    message: 'Only valid email is allowed'
  })
})

const verifyOTPSchema = z.object({
  email: z.string().email({
    message: 'Only valid email is allowed'
  }),
  otp: z.string().min(4, {
    message: 'OTP is required'
  })
})

const changePasswordSchema = z.object({
  email: z.string().email({
    message: 'Only valid email is allowed'
  }),
  password: z
    .string()
    .min(8, {
      message: 'Password should be at least 8 characters long'
    })
    .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,}$/, {
      message:
        'Password must include uppercase, lowercase, number, and special character'
    })
})

const resetPasswordSchema = z.object({
  email: z.string().email({
    message: 'Only valid email is allowed'
  }),
  password: z
    .string()
    .min(8, {
      message: 'Password should be at least 8 characters long'
    })
    .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,}$/, {
      message:
        'Password must include uppercase, lowercase, number, and special character'
    }),
  otp: z.string().min(4, {
    message: 'OTP is required'
  })
})


const setPasswordSchema = z.object({
  email: z.string().email({
    message: 'Only valid email is allowed'
  }),
  password: z
    .string()
    .min(8, {
      message: 'Password should be at least 8 characters long'
    })
    .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,}$/, {
      message:
        'Password must include uppercase, lowercase, number, and special character'
    }),
  otp: z.string().min(4, {
    message: 'OTP is required'
  })
})


export {
  loginSchema,
  forgotPasswordSchema,
  changePasswordSchema,
  verifyOTPSchema,
  resetPasswordSchema,
  setPasswordSchema
}
